import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IWorkflowStoreState } from './workflow.types';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import {
  WorkflowStateAssignmentTypeEnum,
  WorkflowStateEnum,
  WorkflowStateTypeEnum,
  WorkflowTransitionActionTypeEnum
} from '@/models';

export const state: IWorkflowStoreState = {
  workflows: [],
  states: [],
  lastUpsertedWorkflowStateId: null,
  thresholds: [],
  transitions: [],
  transitionActions: [],
  workflowStates: [
    {
      display_name: 'Draft',
      value: WorkflowStateEnum.Draft,
      color: 'draft'
    },
    {
      display_name: 'Published',
      value: WorkflowStateEnum.Published,
      color: 'success'
    }
  ],

  workflowStateTypes: [
    {
      display_name: 'Beginning',
      value: WorkflowStateTypeEnum.Beginning
    },
    {
      display_name: 'Middle',
      value: WorkflowStateTypeEnum.Middle
    },
    {
      display_name: 'End',
      value: WorkflowStateTypeEnum.End
    }
  ],

  workflowStateAssignmentTypes: [
    {
      display_name: 'None',
      value: WorkflowStateAssignmentTypeEnum.None
    },
    {
      display_name: 'Permission Group',
      value: WorkflowStateAssignmentTypeEnum.PermissionGroup
    },
    {
      display_name: 'Organizational Chart',
      value: WorkflowStateAssignmentTypeEnum.OrgChart
    },
    {
      display_name: 'Originator',
      value: WorkflowStateAssignmentTypeEnum.Originator
    }
  ],

  workflowTransitionActionTypes: [
    {
      display_name: 'Send Email',
      value: WorkflowTransitionActionTypeEnum.SendEmail
    },
    {
      display_name: 'Grant Access',
      value: WorkflowTransitionActionTypeEnum.GrantAccess
    }
  ],

  version: 1
};

const namespaced = true;

export const workflow: Module<IWorkflowStoreState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
